import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { StatementDataTable } from "./StatementDataTable";
import { StatementSearchBox } from "./StatementSearchBox";
import { statementDataModel } from "./statementDataModel";


export const StatementDataBox = () => {

    const { contractExport } = statementDataModel();

    const action = (
        <>
            <div>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={contractExport}
                >导出</Button>
            </div >
        </>
    );

    return (
        <>
            <StatementSearchBox />
            <YhBox title={action} >
                <StatementDataTable />
            </YhBox>
        </>
    )
}
